<div class="flex relative overflow-hidden min-h-screen flex-col justify-center lg:px-8 bg-gray-50">
    <app-background></app-background> <!-- CIRCULOS DEL FONDO DE LA PAGINA-->
    <div class="mt-10 sm:mx-auto sm:w-full max-w-[540px]">
        <div class="bg-white opacity-99 px-6 py-12 rounded-lg sm:px-12">
            <div>
                <div class="justify-center">
                    <p class="text-center text-cyan-400 text-2xl md:text-4xl leading-8 font-bold">
                        404</p>
                </div>
                <div class="justify-center mt-4 xl:mt-6">
                    <p class="text-center text-pink-500 text-4xl md:text-5xl leading-8 font-bold">
                        Page not found</p>
                </div>
                <div class="justify-center mt-4 md:mt-6">
                    <p class="text-center text-gray-500 text-sm md:text-sm leading-5 font-medium">
                        Lo sentimos, no pudimos encontrar la pagina que</p>
                    <p class="text-center text-gray-500 text-sm md:text-sm leading-5 font-medium">
                        estas buscando</p>
                </div>
                <div class="relative">
                    <div class="absolute inset-0 flex" aria-hidden="true">
                        <div class="w-full border-t-2 border-gray-200"></div>
                    </div>
                    <div class="relative flex justify-center text-sm/6 font-medium w-7/8 mx-auto mt-4">
                        <button [routerLink]="['/dashboard']" class="button-submit">Volver</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>